import axios from "axios";
import {
  getBaseUrl,
  Microservice,
} from "@funded-here-interface/common/src/constant/baseUrl";
import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";

export interface VirtualAccount {
  id: string;
  accountId: string;
  type: string;
  ref: string;
  createdDate: string;
  currency: string;
  balance: string;
  refId: string;
  bankAccountId: string;
  bankAccountHolder?: string;
  bankName?: string;
  bicSwift?: string;
  isActive?: string;
  orgName?: string;
  orgDetails?: string;
}

export interface VirtualAccountResponse {
  vaAccounts: VirtualAccount[];
  totalRow: number;
}

export interface SortBy {
  field: string;
  order: "asc" | "desc";
}

export interface Filter {
  id: string;
  value: unknown;
}

export interface VirtualAccountRequest {
  token: string;
  page?: number;
  pageSize?: number;
  globalFilter?: string;
  sortBy?: SortBy;
  filter?: Filter[];
  tab: VaAccountTab;
}

export enum VaAccountTab {
  CURRENT_BALANCE = "currentBalance",
  INTERNAL_TRANSFER = "internalTransfer",
}

const getVirtualAccounts = async ({
  token,
  page,
  pageSize,
  globalFilter,
  sortBy,
  filter,
  tab,
}: VirtualAccountRequest): Promise<VirtualAccountResponse> => {
  try {
    let url = `${getBaseUrl(Microservice.PAYMENT)}/payment/account/getVAAccounts?tab=${tab}`;

    if (tab === "currentBalance") {
      url = `${url}&page=${page}&pageSize=${pageSize}`;
      if (globalFilter) {
        url = `${url}&globalFilter=${encodeURIComponent(globalFilter)}`;
      }

      if (sortBy) {
        url = `${url}&sortBy=${encodeURIComponent(JSON.stringify(sortBy))}`;
      }
    }

    if (filter) {
      url = `${url}&filter=${encodeURIComponent(JSON.stringify(filter))}`;
    }

    const response = await axios.get(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      withCredentials: true,
    });

    return response.data;
  } catch (error) {
    const message = getApiResponseErrorMsg(error);

    throw new Error(message);
  }
};

export default getVirtualAccounts;
